import { render, staticRenderFns } from "./TooltipButton.vue?vue&type=template&id=52c177c6&scoped=true&"
import script from "./TooltipButton.vue?vue&type=script&lang=ts&"
export * from "./TooltipButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c177c6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c177c6')) {
      api.createRecord('52c177c6', component.options)
    } else {
      api.reload('52c177c6', component.options)
    }
    module.hot.accept("./TooltipButton.vue?vue&type=template&id=52c177c6&scoped=true&", function () {
      api.rerender('52c177c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shared/shared/components/TooltipButton.vue"
export default component.exports